// Client-side mirror of the backend day/night cycle (catalog.py: DAY_CYCLE_SECONDS, PHASES).
// The server only recomputes time.phase on a state read, and scenes poll every 30s — but a
// phase is just 60s long, so the phase can lag up to half a phase between polls. Since the
// server hands us `time.cycle_started_at_iso`, we can derive the live phase locally each tick.
import { gameState } from './gameState.js';
import { serverNow } from './serverClock.mjs';

export const DAY_CYCLE_SECONDS = 240;
// [name, start, end) in seconds within the cycle — must match backend PHASES.
export const PHASES = [
  ['night', 0, 60],
  ['morning', 60, 120],
  ['day', 120, 180],
  ['evening', 180, 240],
];

// Current time-of-day phase, derived live from the cycle anchor. Honors the dev
// override (T/R hotkeys) and falls back to the server-sent phase if the anchor is missing.
export function currentPhase(now = serverNow()) {
  if (gameState._devPhase) return gameState._devPhase;
  const iso = gameState.raw?.time?.cycle_started_at_iso;
  if (!iso) return gameState.raw?.time?.phase ?? 'night';
  const started = new Date(iso).getTime();
  let s = ((now - started) / 1000) % DAY_CYCLE_SECONDS;
  if (s < 0) s += DAY_CYCLE_SECONDS;
  for (const [name, start, end] of PHASES) {
    if (s >= start && s < end) return name;
  }
  return PHASES[0][0];
}
